/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosGeneralAnalyticsRequest = {
    chartType?: AptosGeneralAnalyticsRequest.chartType;
    periodType?: AptosGeneralAnalyticsRequest.periodType;
    stime?: number;
    etime?: number;
};

export namespace AptosGeneralAnalyticsRequest {

    export enum chartType {
        USER_TRX = 'USER_TRX',
        TPS_AVG = 'TPS_AVG',
        PEAK_TPS = 'PEAK_TPS',
        ACTIVE_ACCOUNT_OF_DAY = 'ACTIVE_ACCOUNT_OF_DAY',
        ACTIVE_ACCOUNT_OF_MONTH = 'ACTIVE_ACCOUNT_OF_MONTH',
        NEW_ACCOUNT = 'NEW_ACCOUNT',
        GAS_CONSUMPTION = 'GAS_CONSUMPTION',
        GAS_UNIT_PRICE_AVG = 'GAS_UNIT_PRICE_AVG',
    }

    export enum periodType {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        D180 = 'D180',
        D365 = 'D365',
        YTD = 'YTD',
        ALL = 'ALL',
        MANUAL = 'MANUAL',
    }


}

